module.exports = __webpack_public_path__ + "media/images/mobile/close_menu-86d8518e2c55f296ff04531da1c87ec5.png";